
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogFooter
} from "@/components/ui/dialog";
import { Doctor } from '@/types';
import { shouldUseMockData } from '@/services/api';
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";

interface ScheduleDialogProps {
  isOpen: boolean;
  doctor: Doctor | null;
  onClose: () => void;
}

const ScheduleDialog: React.FC<ScheduleDialogProps> = ({
  isOpen,
  doctor,
  onClose
}) => {
  const [date, setDate] = useState<Date | undefined>(new Date());
  const isMockMode = shouldUseMockData();
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            {doctor ? `Manage Schedule for ${doctor.name}` : 'Manage Schedule'}
          </DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          {isMockMode ? (
            <div className="space-y-4">
              <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-md text-yellow-800">
                <p className="font-medium">Running in Mock Mode</p>
                <p className="text-sm mt-1">
                  You are currently seeing mock data because the backend server is not connected.
                  To see and manage real schedules, deploy your backend and update the API URL in your environment settings.
                </p>
              </div>
              
              <div className="flex justify-center p-4">
                <Calendar
                  mode="single"
                  selected={date}
                  onSelect={setDate}
                  className="rounded-md border"
                />
              </div>
              
              <div>
                <h3 className="font-medium mb-2">Selected Date: {date ? format(date, "PPP") : "None"}</h3>
                <div className="grid grid-cols-3 gap-2">
                  {["09:00", "09:30", "10:00", "10:30", "11:00", "11:30"].map((time) => (
                    <div key={time} className="p-2 border rounded-md text-center hover:bg-slate-50 cursor-pointer">
                      {time}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <p>Schedule management functionality would go here.</p>
          )}
        </div>
        
        <DialogFooter>
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleDialog;
